import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  associatonWarning: {
    margin: theme.spacing(2, 0)
  },
  alertContainer: {
    marginBottom: theme.spacing(3)
  }
}));
